"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteUpcomingHearingsParams = exports.PaginatedUpcomingHearings = exports.UpcomingHearingsQueryParams = void 0;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
const refine_1 = require("../util/refine");
const joda_schemas_1 = require("./joda.schemas");
const list_schemas_1 = require("./list.schemas");
const upcoming_hearing_schemas_1 = require("./upcoming-hearing.schemas");
const UpcomingHearingsQueryParamsSchema = list_schemas_1.PaginationQueryParamsSchema.merge(zod_1.default.object({
    courtSystemId: zod_1.default.string().uuid(),
    fromDate: joda_schemas_1.LocalDateSchema.optional(),
    toDate: joda_schemas_1.LocalDateSchema.optional(),
    locationId: zod_1.default.string().uuid().optional(),
    caseReference: zod_1.default.string().optional(),
    searchTerm: zod_1.default.string().optional(),
}));
exports.UpcomingHearingsQueryParams = UpcomingHearingsQueryParamsSchema.refine((refine_1.is));
const PaginatedUpcomingHearingsSchema = (0, list_schemas_1.createPaginatedResponseSchema)(upcoming_hearing_schemas_1.UpcomingHearing);
exports.PaginatedUpcomingHearings = PaginatedUpcomingHearingsSchema.refine((refine_1.is));
const DeleteUpcomingHearingsParamsSchema = zod_1.default.object({
    courtSystemId: zod_1.default.string().uuid(),
    locationId: zod_1.default.string().uuid(),
    fromDate: joda_schemas_1.LocalDateSchema,
    toDate: joda_schemas_1.LocalDateSchema,
});
exports.DeleteUpcomingHearingsParams = DeleteUpcomingHearingsParamsSchema.refine((refine_1.is));
